const TransporteurDashboard: React.FC = () => {
  return <div>En construction</div>;
};

export default TransporteurDashboard;
